import secureApi from "../services/secureApi";

export const getCoupons = async (page = 1, limit = 10) => {
  try {
    const response = await secureApi.get("/admin/coupon/list", {
      params: {
        page,
        limit,
      },
    });

  
    return response.data;
  } catch (error) {
    return {
      data: [],
      pagination: {
        total: 0,
      },
    };
  }
};

// VIEW COUPON
export const getCouponById = async (id) => {
  try {
    const response = await secureApi.get(`/admin/coupon/view/${id}`);
    return response?.data?.data || response?.data || null;
  } catch (error) {
    return null;
  }
};

// ADD
export const addCoupon = async (data) => {
  try {
    const response = await secureApi.post("/admin/coupon/add", data);
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

// EDIT
export const editCoupon = async (id, data) => {
  try {
    const response = await secureApi.patch(`/admin/coupon/edit/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

// DELETE
export const deleteCoupon = async (id) => {
  try {
    const response = await secureApi.delete(`/admin/coupon/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};